<template>
  <div>
    <contacts-dashboard
      :isLoading="$apollo.loading"
      :contact-accounts="contactAccounts">
    </contacts-dashboard>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import addContactAccount from '@/graphql/contacts/addContactAccount.gql';
import contactAccountsListQuery from '@/graphql/contacts/contactAccountsList.gql';
import mailChimpAccessToken from '@/graphql/contacts/mailChimpAccessToken.gql';
import ContactsDashboard from '@/components/audience/ContactsDashboard';

export default {
  name: 'ContactsContainer',
  components: {
    ContactsDashboard,
  },
  computed: {
    ...mapState('user', ['me'], 'contacts'),
  },
  data: () => ({
    contactAccounts: [],
    dialogVisible: true,
  }),
  apollo: {
    $client: 'apiv2',
    contactAccounts: {
      query: contactAccountsListQuery,
      prefetch: true,
    },
  },
  mounted() {
    if (this.$route.params) {
      switch (this.$route.params.authProvider) {
        case 'constant_contact':
          this.addConstantContactAccount();
          break;
        case 'mail_chimp':
          this.addMailChimpAccount();
          break;
        default: break;
      }
    }
  },
  methods: {
    async addConstantContactAccount() {
      const params = this.parseHashParams(this.$route.hash);
      await this.addContactAccount(params.access_token, this.$route.params.authProvider);
    },

    async addMailChimpAccount() {
      const code = this.$route.query.code;
      try {
        const res = await this.$apollo.query({
          $client: 'apiv2',
          query: mailChimpAccessToken,
          variables: {
            code,
          },
        });
        await this.addContactAccount(
          res.data.accessToken.accessToken,
          this.$route.params.authProvider,
        );
      } catch (err) {
        this.$notify({
          title: 'Error!',
          message: 'Something went wrong while fetching access token.',
          type: 'error',
        });
      }
    },

    async addContactAccount(bearerToken, provider) {
      try {
        await this.$apollo.mutate({
          $client: 'apiv2',
          mutation: addContactAccount,
          variables: {
            bearerToken,
            provider,
          },
        });
        this.$notify({
          title: 'Success!',
          message: 'Contact account has succesfully been added!',
          type: 'success',
        });
        await this.refetchContactAccounts();
      } catch (err) {
        this.$notify({
          title: 'Error!',
          message: 'Unable to save contact account: does account already exist?',
          type: 'error',
        });
      }
    },

    refetchContactAccounts() {
      this.$apollo.queries.contactAccounts.refresh();
    },

    parseHashParams(string) {
      let dict = {};
      const paramString = string.replace('#', '');
      const params = paramString.split('&');
      for (let i = 0; i < params.length; i += 1) {
        const [key, val] = params[i].split('=');
        dict = { [key]: val, ...dict };
      }
      return dict;
    },
  },
};
</script>


// WEBPACK FOOTER //
// ContactsContainer.vue?89c90e58